/**
 * Sheet / modal de paywall contextual → navega a Activar plan Crece.
 */
import React from 'react';
import { Modal } from '../../../shared/modals/Modal';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { typography } from '../../../shared/theme/typography';
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export type CrecePaywallCopy = {
  eyebrow: string;
  title: string;
  body: string;
  cta: string;
  dismiss: string;
};

type Props = {
  visible: boolean;
  copy: CrecePaywallCopy;
  onActivate: () => void;
  onDismiss: () => void;
};

export function CrecePaywallSheet({ visible, copy, onActivate, onDismiss }: Props) {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onDismiss}>
      <View style={styles.backdrop}>
        <View style={styles.card} accessibilityViewIsModal>
          <Text style={styles.eyebrow}>{copy.eyebrow}</Text>
          <Text style={styles.title}>{copy.title}</Text>
          <Text style={styles.body}>{copy.body}</Text>
          <TouchableOpacity style={styles.primaryBtn} onPress={onActivate} accessibilityRole="button">
            <Text style={styles.primaryBtnText}>{copy.cta}</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.secondaryBtn} onPress={onDismiss} accessibilityRole="button">
            <Text style={styles.secondaryBtnText}>{copy.dismiss}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.55)',
    justifyContent: 'flex-end',
    padding: spacing.lg,
  },
  card: {
    borderRadius: 20,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.lg,
    gap: spacing.md,
    maxWidth: 420,
    width: '100%',
    alignSelf: 'center',
  },
  eyebrow: {
    fontFamily: ticketFonts.sans,
    fontSize: 12,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.06,
  },
  title: {
    ...typography.titleLg,
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  body: {
    ...typography.body,
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink2,
    lineHeight: 22,
  },
  primaryBtn: {
    borderRadius: 10,
    backgroundColor: ticketColors.crece,
    paddingVertical: spacing.md,
    alignItems: 'center',
  },
  primaryBtnText: {
    fontFamily: ticketFonts.sans,
    color: ticketColors.creceInk,
    fontWeight: '800',
    fontSize: 16,
  },
  secondaryBtn: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingVertical: spacing.sm,
    alignItems: 'center',
  },
  secondaryBtnText: {
    fontFamily: ticketFonts.sans,
    color: ticketColors.ink,
    fontWeight: '700',
  },
});
